/// <reference path="../Accountings/AccountingsGrid.ts" />

namespace Nobox.CRM {

    import fld = AccountingsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class DealsAccountingGrid extends AccountingsGrid {
        protected getDialogType() { return DealsAccountingsDialog; }

        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.editItem({ DealId: this.dealId, PlId: this.plId });
        }

        protected getColumns() {
            var column = super.getColumns();
            const fieldName = "DealNm";
            var index = -1;
            $.grep(column, function (obj, i) {
                if (obj.field === fieldName) {
                    index = i;
                    return true; // Stop iterating after finding the first match
                }
            });
            column[index].visible = false;
            return column;
        }
        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.dealId;
        }

        private _GroupID: string;
        public plId: string;
        get dealId() {
            return this._GroupID;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            //request.ColumnSelection = 1;
            request.EqualityFilter = { DealId: this.dealId};
        }
        set dealId(value: string) {
            if (this._GroupID !== value) {
                this._GroupID = value;
                this.refresh();
            }
        }
    }
}